import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AffiliateSectionLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AmazonPreviewLink/AmazonPreviewLink.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/BreadCrumb/BreadCrumb.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/DealsCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/GenerateAffiliateSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/Image.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Image/NextImage.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Image/NextImage.css");
;
import(/* webpackMode: "eager" */ "/app/app/(bookDetailPageLayout)/ebook/[...BookDetail]/bookDetailPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Meta.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/NewsletterBanner/NewsletterBanner.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ShowContributor.js");
;
import(/* webpackMode: "eager" */ "/app/src/services/RouteService.js");
